// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"117":"procesos","683":"bases"}[chunkId] || chunkId) + "." + {"100":"87de7362","117":"9a413df0","220":"4feedc8f","296":"ed321330","394":"8221bdd8","610":"87de7362","640":"48236483","683":"9a413df0","792":"87de7362","894":"d5ee6291","963":"8f10a335"}[chunkId] + ".css";
};